// ConfirmStep.tsx
import Typography from '@material-ui/core/Typography';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import { OCR_REMIND } from 'constants/Icons';
import ConfirmUI from '../Components/ConfirmUI';
import styles from '../index.module.css';
import { ConfirmText, LICENSE_PAGE_URL } from '../utils';

export const ConfirmRemind = ({ onClose }: { onClose: () => void }) => {
  const classes = clsx(styles.StepContainer, styles.confirmClose, styles.flexColCenter);

  const handleNextStep = () => {
    window.location.href = LICENSE_PAGE_URL;
  };

  const onRedirectToHome = () => onClose();

  return (
    <ConfirmUI classes={classes} buttonNext={ConfirmText.Close} buttonClose="Bỏ qua" onNext={handleNextStep} onClose={onRedirectToHome}>
      <div className={styles.title}>
        <OCR_REMIND />
        <Typography>Tài khoản chưa được kích hoạt</Typography>
      </div>
      <div className={styles.flexColCenter}>
        <Box className={styles.flexRow}>
          <Typography className={styles.content}>
            Bạn cần
            <Typography component="span" className={styles.strongContent}>
              &nbsp;xác thực giấy phép&nbsp;
            </Typography>
            để được kích hoạt tài khoản mua hàng tại thuocsi.vn
          </Typography>
        </Box>
      </div>
    </ConfirmUI>
  );
};
